export default __webpack_public_path__ + "static/media/settings-light.1c89da53.svg";